import pdfjsLib from 'pdfjs-dist';
//import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry.js';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export { pdfjsLib };